<template>
  <div class="content-box">
    <!-- 마이페이지 사용자정보 -->
    <HconMyPageUsrInfo />
    <div class="sub-wrapper">
      <!-- 마이페이지 사이드 메뉴 -->
      <HconMyPageSideMenu />
      <div class="sub-contents">
        <div class="contents-title-wrap">
          <div class="contents-title">
            <h3>최근 구매내역</h3>
            <p>(최근 1개월/결제완료 기준)</p>
          </div>
          <div class="rgt-area">
            <NuxtLink to="/pc/mypage/order" class="link-btn gray100">전체보기</NuxtLink>
          </div>
        </div>
        <div class="contents-detail-wrap">
          <table class="tbl-type">
            <caption>최근 구매내역</caption>
            <colgroup>
              <col style="width: 22%;">
              <col style="width: auto;">
              <col style="width: 13%;">
              <col style="width: 17%;">
            </colgroup>
            <thead>
              <tr>
                <th scope="col">주문번호/주문일시</th>
                <th scope="col">주문명/상품명</th>
                <th scope="col">결제금액</th>
                <th scope="col">발신유형/건수</th>
              </tr>
            </thead>
            <!-- 데이터 있음 -->
            <tbody v-if="OrderList.length > 0">
              <tr v-for="(order, index) in OrderList" :key="index">
                <td class="xs">
                  <div class="order-number">
                    <NuxtLink :to="getOrderDetailPath(order)" class="link-underline">
                      <p>{{order.ordNo}}</p>
                      <span>{{HconCommonUtils.format.dateTimeNoSec(order.ordDtm)}}</span>
                    </NuxtLink>
                  </div>
                </td>
                <td class="xs">
                  <div class="product-box">
                    <div class="thumb-wrap">
                      <NuxtLink :to="getOrderDetailPath(order)" class="thumb-img">
                        <img :src="order.cpnTnailImgPath" alt="">
                      </NuxtLink>
                    </div>
                    <div class="product-info">
                      <NuxtLink :to="getOrderDetailPath(order)">
                        <p class="product-tit">{{order.ordNm}}</p>
                        <p class="product-detail">{{order.hcDspGdsNm}}</p>
                      </NuxtLink>
                    </div>
                  </div>
                </td>
                <td class="xs">{{HconCommonUtils.format.expComma(order.ordTotAmt)}}원</td>
                <td class="xs">{{order.hcCpnSndPntmNm}}/{{order.allOrdGdsQty}}건</td>
              </tr>
            </tbody>
            <!-- 데이터 없음 -->
            <tbody v-else>
              <tr>
                <td colspan="4" class="nodata">최근 구매 내역이 없습니다.</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div> 
  </div>
</template>
<script lang="ts" setup>
import { ref, onMounted } from 'vue';
import HconMyPageSideMenu from '@/components/corner/pc/HconCornerMypageSideMenuPC.vue';
import HconMyPageUsrInfo from '@/components/corner/pc/HconCornerUserInfoPC.vue';
import { useHconFetchBuilder } from "~/composables/hcon-fetch-builder";
import type {RecentOrderListDto } from '~/types/mypage/backend-dto-types';

// 팝업
const {showAlert} = usePopup()

// 마이페이지 홈 초기 호출 API 목록
onMounted (() => {
  recentOrderList();
})

// 최근구매내역 정보 조회 API 결과 값
const OrderList = ref<RecentOrderListDto[]>([]);

const fetchBuilder  = useHconFetchBuilder();

// 최근구매내역 정보 조회 API 호출
const recentOrderList = async () => {
  const fetchBuilderResult = 
  await fetchBuilder.get<AjaxResult<RecentOrderListDto[]>>('/api/v1/mypage/order/recent-order-list')
  .query()
  .progressMessage("잠시만 기다려주세요...")
  .preventErrorNotify()
  .build()
  .execute()
  .then((result) => {
    if(result.resultCode == '200') {
      const dataResult = result.data.map((item) => ({
        ordNo: item.ordNo,
        ordDtm: item.ordDtm,
        ordNm: item.ordNm,
        hcCpnSndPntmNm: item.hcCpnSndPntmNm,
        allOrdGdsQty: item.allOrdGdsQty,
        ordTotAmt: item.ordTotAmt,
        hcDspGdsNm: item.hcDspGdsNm,
        cpnTnailImgPath: cu.getFileFullUrl(item.cpnTnailImgPath),
        cpnTnailImgFileNm: item.cpnTnailImgFileNm,
        hcOrdTypCd: item.hcOrdTypCd
      }))
      OrderList.value = dataResult
    }
  })
  .catch((error) => {
    // 응답코드가 200이 아닌경우
    if(error.resultCode != '200') {
      showAlert(error.resultMessage)
    }
  })
}

// PIN주문 상세화면 분기처리
const getOrderDetailPath = (order: RecentOrderListDto) => {
  if(order.hcOrdTypCd === '1002') { 
    return `/pc/mypage/order/pin-detail/${order.ordNo}`;
  } else {
    return `/pc/mypage/order/detail/${order.ordNo}`;
  }
}

</script>
<style lang="scss" scoped>
@use "@/assets/scss/pc/mypage-hcon.scss" as *;
</style>